<template>
	<b-list-group flush>
		<spells-card-level v-for="(spellsKnown, spellLevel) in spellsKnown" :key="spellLevel" :spell-level="spellLevel" :spell-save-dc="spellsSaveDC[spellLevel]" :spells-known="spellsKnown" :spells-per-day="spellsPerDay[spellLevel]">

		</spells-card-level>
	</b-list-group>
</template>

<script>
import {mapGetters} from 'vuex'
import SpellsCardLevel from '@/components/play/SpellsCardLevel.vue'

export default {
	components: {
		SpellsCardLevel,
	},
	computed: {
		Character: function(){
			return this.$store.state.Character
		},
		...mapGetters([
			'abilityMods',
		]),
		...mapGetters('character/spells',{
			spellsKnown: 'known',
			spellsList: 'list',
			spellsPerDay: 'perDay',
			spellsSaveDC: 'saveDC',
		}),
		SpellSlots: {
			get: function() {
				return false;
			},
			set: function() {

			}
		}
	},
}
</script>

<style scoped>

</style>